import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

import './styles.scss'

import './utilities/extensions'
import Printer from './components/printer';

library.add(fas, far, fab)

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Printer>
    <App />
  </Printer>
);